import React from 'react';
import styles from './replyPageContent.module.scss';

const ReplyPageContent: React.FC = () => {
    return (
        <div className={styles.wrapper}>
            <div className={styles.content}>
                REPLAY
            </div>
        </div>
    );
};

export default ReplyPageContent;